var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:[ 'app-tab-button', 'flex', 'is-centered', (_vm.selected && 'is-selected') ],attrs:{"to":_vm.to}},[_c('span',{staticClass:"icon"},[_c('span',{class:("icon-" + _vm.icon)})])])}
var staticRenderFns = []

export { render, staticRenderFns }